<template>
  <!-- <div id="sticky-nav" class="wrapper" > -->
  <div class="wrapper">
    <!--普通基金行情-->
    <fundHeader
      v-if="!isNewFund && !isExchangeFund && !isDelListedFund "
      :basic-info="basicInfo"
      ref="FundHeader" />

    <!--场内基金行情-->
    <fundcnHeader v-if="isExchangeFund && !isDelListedFund && !isNewFund" ref="FundcnHeader" />

    <!--新发基金Header-->
    <fundxfHeader v-if="isNewFund && !isDelListedFund" ref="FundxfHeader" />

    <div class="wrapper-ts" v-if="isDelListedFund">
      <div class="header-ts">

        <FundNameView :name="pageData.SHORTNAME" :code="pageData.FCODE" />
        <div class="stop-hsale-label" v-if="!nodata">已于{{pageData.TSRQ}}退市</div>
        <div class="stop-hsale-label" v-else >--</div>
      </div>
    </div>

  </div>
</template>

<script>
import JS from '@/base/JSTool';
import Util from '@/base/Util';
import FundNameView from '@/components/Fund-FundNameVIew.vue';
import fundHeader from '@/components/Fund-Header.vue';
import fundcnHeader from '@/components/Fund-CnHeader.vue';
import fundxfHeader from '@/components/Fund-XfHeader.vue';
import StoreManger from '@/utils/FundHQJHManger';
import {
  setNavBarScroll,
  recordBrowseFund,
  setNavTitle,
  getIs50Sys,
} from '@/utils/nativeBridge';
import FundTypeSearch from '@/utils/FundTypeSearch';
import NativeMsg from '@/base/NativeMsg';
import { setTrace } from '@fund/foot-trace';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
// import stickybits from 'stickybits';

export default {
  name: 'WarningTip',
  components: {
    FundNameView,
    fundHeader,
    fundcnHeader,
    fundxfHeader,
  },
  props: {
    basicInfo: {
      type: Object,
    },
  },
  data() {
    return {
      pageData: { TSRQ: '--' },
      fundCode: '',
      fundType: '',
      headerClass: '',
      hadMarkHist: false,
      hadDownSHow: true,
      isTS: false, // 退市
      nodata: false,
    };
  },
  computed: {
    isExchangeFund() {
      return isEmpty(this.basicInfo) ? FundTypeSearch.isExchangeFund(this.fundType)
        : this.basicInfo.isETF;
    },
    isNewFund() {
      return isEmpty(this.basicInfo) ? FundTypeSearch.isNewFund(this.fundType)
        : this.basicInfo.isNewFund;
    },
    isMonetaryfund() {
      return isEmpty(this.basicInfo) ? FundTypeSearch.isMonetaryfund(this.fundType)
        : this.basicInfo.isCurrencyFund;
    },
    isDelListedFund() {
      return this.basicInfo?.isDelListedFund;
    },
  },
  created() {
    console.log('set onPageShow and onPageHide');
    // 原生交互已下线
    NativeMsg.reg('onPageShow', () => {
      console.log('get onPageShow');
      this.recordFund();
    });
    NativeMsg.reg('onPageHide', () => {
      console.log('get onPageHide');
      this.recordFund();
    });
    try {
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      if (fundDetail.onNativeMessageRegistered) {
        console.log('fundDetail.onNativeMessageRegistered');
        // eslint-disable-next-line no-undef
        fundDetail.onNativeMessageRegistered('');
      }
      // #endif
    } catch (error) {
      console.log(error);
    }

    NativeMsg.reg('refreshHeaderState', () => {
      console.log('refreshHeaderState');
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
    });
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
  },
  mounted() {
    // stickybits('#sticky-nav');
    this.fundCode = this.basicInfo.fundCode;
  },
  methods: {
    render(isCache) {
      this.fundCode = this.$store.state.native.fund.fundCode;
      const baseInfo = StoreManger.getFundJJXQ();
      if (baseInfo) {
        this.pageData = baseInfo;
        const endDate = new Date(baseInfo.TSRQ.replace(/-/g, '/')).getTime();
        const serverDate = new Date().getTime();
        if (serverDate > endDate) {
          this.isTS = true;
        } else {
          this.isTS = false;
        }
      } else {
        this.isTS = true;
        this.nodata = true;
      }
      this.$nextTick(() => {
        this.fundCode = this.$store.state.native.fund.fundCode;
        this.fundType = this.$store.state.native.fund.fundType;
        // console.log(`========head render ${this.fundCode}`);
        const refs = this.$refs;
        if (this.isNewFund) {
          if (refs.FundxfHeader) {
            refs.FundxfHeader.render(isCache);
          }
        } else if (this.isExchangeFund) {
          if (refs.FundcnHeader) {
            refs.FundcnHeader.render(isCache);
          }
        } else if (refs.FundHeader) {
          refs.FundHeader.render(isCache);
        }
        const nowbaseInfo = StoreManger.getFundJJXQ();
        if (nowbaseInfo) {
          this.configureTitle();
          this.queryUserAll();
        }
      });
      this.queryGetFundProductProfit();
    },
    async queryGetFundProductProfit() {
      const info = await this.$getUserInfo();
      const {
        uid,
      } = info;
      // #if EXECUTION_ENV === 'fund'
      if (uid && uid.length > 0) {
        const baseInfo = StoreManger.getFundJJXQ();
        const hdcdoe = baseInfo.BACKCODE;
        let code = this.fundCode;
        if (hdcdoe && hdcdoe !== '--') {
          code = `${this.fundCode},${hdcdoe}`;
        }
        const updateParam = {
          uid,
          FundCode: `${code}`,
        };
        await this.$store.dispatch('updateFundProductProfit', updateParam).catch((e) => {
          console.log(e);
        });
        NativeMsg.post(JSON.stringify({ key: 'reloadUserProfit', value: { v: 'reloadUserProfit' } }));
      }
      // #endif
    },
    async queryUserAll() {
      const info = await this.$getUserInfo();
      const {
        uid,
      } = info;
      // #if EXECUTION_ENV === 'fund'
      if (uid && uid.length > 0) {
        const UserAllStatuData = this.$store.state.tradeInfo.fund[`UserAllStatu${uid}`];
        if (!UserAllStatuData) {
          this.$store.dispatch('updateGetUserAllStatu', uid);
        }
      }
      // #endif
    },
    newfootTrade(fundCode, fundName) {
      console.log(fundCode);
      console.log(fundName);
      // #if EXECUTION_ENV === 'fund'

      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      let cansetTrace = false;
      if (systemInfo) {
        if (systemInfo.version) {
          if (systemInfo.version >= '6.4.9') {
            cansetTrace = true;
          }
        }
      }
      console.log(`${fundCode} === setTrace`);
      if (cansetTrace) {
        console.log('newfootTrade');
        try {
          const res = setTrace({
            code: `${fundCode}`,
            name: `${fundName}`,
            ftype: 0,
          }, 1);
          console.log(`setTrace ====== ${res}`);
        } catch (error) {
          console.log('setTrace ====== catch');
          console.log(error);
        }
      }
      // #endif
    },
    recordFund() { // 记录足迹，2023.12.13 web不支持
      // 足迹
      if (!this.hadMarkHist) {
        this.hadMarkHist = true;
        const timer = setInterval(() => {
          // const baseInfo = StoreManger.getFundJJXQ();
          if (this.basicInfo) {
            const { fundCode, fundName } = this.baseInfo;
            recordBrowseFund({ fundCode, fundName }).then(() => {
              console.log('===> add fund record success', fundCode, fundName);
            }).catch(() => {
            });
            this.newfootTrade(fundCode, fundName); // web不走，不执行
            clearInterval(timer);
          }
        }, 300);
      }
    },
    getCnUpTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        DWJZ, RZDF, SHORTNAME,
      } = baseInfo;
      let cor = '#ff0000';
      if (parseFloat(RZDF) === 0) {
        cor = '#000000';
      } else if (parseFloat(RZDF) < 0) {
        cor = '#12b412';
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${parseFloat(DWJZ).toFixed(4)}   ${RZDF ? parseFloat(RZDF).toFixed(2) : '--'}%`,
        fundCode: this.getfundCode(),
        scrollType: 'down',
        subTitleColor: cor,
      };
      return navData;
    },
    getPGUpTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        DWJZ, RZDF, SHORTNAME,
      } = baseInfo;
      let cor = '#000000';
      if (parseFloat(RZDF) === 0) {
        cor = '#000000';
      } else if (parseFloat(RZDF) < 0) {
        cor = '#12b412';
      } else if (parseFloat(RZDF) > 0) {
        cor = '#ff0000';
      }
      let zdf = '--';
      if (RZDF && RZDF !== '--') {
        zdf = `${parseFloat(RZDF).toFixed(2)}%`;
      }
      let dwjzStr = '--';
      if (DWJZ && DWJZ !== '--') {
        dwjzStr = `${parseFloat(DWJZ).toFixed(4)}`;
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${dwjzStr}   ${zdf}`,
        fundCode: this.getfundCode(),
        scrollType: 'down',
        subTitleColor: cor,
      };
      return navData;
    },
    getfundCode() {
      return this.fundCode ? this.fundCode : '--';
    },
    getPGDownTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        SGZT, SHZT, SHORTNAME, ISSALES, ISLIST,
      } = baseInfo;
      if (this.isExchangeFund && ISLIST === '1') {
        const navData = {
          title: SHORTNAME,
          subTitle: `${this.fundCode} ${SGZT} ${SHZT}`,
          fundCode: this.getfundCode(),
          scrollType: 'up',
          subTitleColor: '#000000',
        };
        return navData;
      }
      if (ISSALES === '1') {
        const navData = {
          title: SHORTNAME,
          subTitle: `${this.fundCode} ${SGZT} ${SHZT}`,
          fundCode: this.getfundCode(),
          scrollType: 'up',
          subTitleColor: '#000000',
        };
        return navData;
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${this.fundCode} 暂不销售`,
        fundCode: this.getfundCode(),
        scrollType: 'up',
        subTitleColor: '#000000',
      };
      return navData;
    },
    getHBUpTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        DWJZ, LJJZ, SHORTNAME,
      } = baseInfo;
      let cor = '#000000';
      if (parseFloat(LJJZ) === 0) {
        cor = '#000000';
      } else if (parseFloat(LJJZ) < 0) {
        cor = '#12b412';
      } else if (parseFloat(LJJZ) > 0) {
        cor = '#ff0000';
      }
      let zdf = '--';
      if (LJJZ && LJJZ !== '--') {
        zdf = `${parseFloat(LJJZ).toFixed(4)}%`;
      }
      let wfsy = JS.fetchString(baseInfo, 'DWJZ');
      if (wfsy && wfsy !== '--') {
        wfsy = `${parseFloat(DWJZ).toFixed(4)}`;
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${wfsy}   ${zdf}`,
        fundCode: this.getfundCode(),
        scrollType: 'down',
        subTitleColor: cor,
      };
      return navData;
    },
    getHBDownTitleData() {
      return this.getPGDownTitleData();
    },
    getXFUpTitleData() {
      const item = this.getXFDownTitleData();
      item.scrollType = 'down';
      return item;
    },
    getnewFundTip() {
      if (this.isExchangeFund) {
        return '';
      }
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        return '';
      }
      const {
        ISSBDATE, ISSEDATE, ISSALES, TSRQ, SGZT,
      } = baseInfo;
      if (ISSALES !== '1') {
        return '暂不销售';
      }
      const saleEndDate = new Date(TSRQ.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();
      if (serverDate > saleEndDate) {
        return '暂不开放购买';
      }

      if (Util.isEmpty(ISSBDATE) || Util.isEmpty(ISSEDATE)) {
        // console.log('zzz2');
        return '';
      }
      const startDate = new Date(ISSBDATE.replace(/-/g, '/')).getTime();
      const endDate = new Date(ISSEDATE.replace(/-/g, '/')).getTime();

      if (endDate > startDate) {
        if (startDate > serverDate) {
          return '暂不销售';
        }
        if (endDate >= serverDate) {
          return SGZT;
        }
        return '募集结束 等待成立';
      }
      // console.log('zzz3');
      return '';
    },
    getXFDownTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        SHORTNAME,
      } = baseInfo;
      const navData = {
        title: SHORTNAME,
        subTitle: `${this.fundCode}  ${this.getnewFundTip()}`,
        fundCode: this.getfundCode(),
        scrollType: 'up',
        subTitleColor: '#000000',
      };
      return navData;
    },
    getValueStrWithKey(item, key) {
      const res = JS.fetchString(item, key);
      return res || '--';
    },
    pageUpShow() {
      if (!this.hadDownSHow) {
        return;
      }
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        return;
      }
      this.hadDownSHow = false;
      let item = this.getPGUpTitleData();
      if (this.isNewFund) {
        item = this.getXFUpTitleData();
      } else if (this.isMonetaryfund) {
        item = this.getHBUpTitleData();
      } else if (this.isExchangeFund) {
        // 不处理
        // item = this.getCnUpTitleData();
        const refs = this.$refs;
        if (this.isExchangeFund) {
          if (refs.FundcnHeader) {
            refs.FundcnHeader.pageUpShow();
          }
        }
        return;
      } else {
        item = this.getPGUpTitleData();
      }
      const upItem = item;
      upItem.scrollType = 'up';
      // 超过100px
      this.confScrollTitle(upItem);
    },
    pageDownShow() {
      if (this.hadDownSHow) {
        return;
      }
      this.hadDownSHow = true;
      // 小于100px
      let item = this.getPGDownTitleData();
      if (this.isNewFund) {
        item = this.getXFDownTitleData();
      } else if (this.isMonetaryfund) {
        item = this.getHBDownTitleData();
      } else if (this.isExchangeFund) {
        // 不处理
        const refs = this.$refs;
        if (this.isExchangeFund) {
          if (refs.FundcnHeader) {
            refs.FundcnHeader.pageDownShow();
          }
        }
        return;
      } else {
        item = this.getPGDownTitleData();
      }
      const upItem = item;
      upItem.scrollType = 'down';
      // 小于100px
      this.confScrollTitle(item);
    },
    confScrollTitle(item) {
      if (getIs50Sys()) {
        return;
      }
      const nativeData = this.$store.state.native.fund;
      if (nativeData.oldFundCode) {
        // eslint-disable-next-line no-param-reassign
        item.fundCode = nativeData.oldFundCode;
        setNavBarScroll(item).then(() => {
        }).catch(() => {
        });
      } else {
        setNavBarScroll(item).then(() => {
        }).catch(() => {
        });
      }
    },
    configureTitle() {
      // 大于100px
      if (this.isNewFund) {
        this.pageLoadNav(this.getXFUpTitleData());
      } else if (this.isMonetaryfund) {
        this.pageLoadNav(this.getHBUpTitleData());
      } else if (this.isExchangeFund) {
        // 不处理
      } else {
        this.pageLoadNav(this.getPGUpTitleData());
      }
      // 小于100px
      if (this.isNewFund) {
        this.pageLoadNav(this.getXFDownTitleData());
      } else if (this.isMonetaryfund) {
        this.pageLoadNav(this.getHBDownTitleData());
      } else if (this.isExchangeFund) {
        // 不处理
      } else {
        this.pageLoadNav(this.getPGDownTitleData());
      }
    },
    pageLoadNav(item) {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        SHORTNAME,
      } = baseInfo;
      document.title = SHORTNAME;
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      if (systemInfo) {
        if (systemInfo.system) {
          if (systemInfo.system.indexOf) {
            if (systemInfo.system.indexOf('iOS')) {
              // eslint-disable-next-line no-param-reassign
              item.scrollType = '';
            }
          }
        }
      }
      // #endif
      if (!getIs50Sys()) {
        const nativeData = this.$store.state.native.fund;
        if (nativeData.oldFundCode) {
          // eslint-disable-next-line no-param-reassign
          item.fundCode = nativeData.oldFundCode;
          setNavTitle(item).then(() => {
          }).catch(() => {
          });
        } else {
          setNavTitle(item).then(() => {
          }).catch(() => {
          });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper{
  align-items: center;
}

.right-arrow-a{
  width: 30px;
  height: 30px;
  position: absolute;
  right: 20px;
  z-index: 99;
  align-items: center;
  display: flex;
  margin-top: 90px;
}

.right-arrow-v{
  width: 30px;
  height: 30px;
}
.stop-hsale{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 2px solid #eee;
  background: #999999;
}
.stop-hsale-label{
  font-family: DINAlternate-Bold;
  padding-top: 60px;
  padding-bottom: 60px;
  padding-right: 24px;
  font-size: 36px;
  color: #999999;
  width: 100%;
  align-items: center;
  text-align: left;
}

.wrapper-ts {
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
}
.header-ts {
  border-radius: 10px;
  position: relative;
  padding-left: 24px;
  padding-right: 10px;
  background: #ffffff;
  color: #000;
}
</style>
